import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
    {
      question: 'How should SEO be incorporated with our overall marketing strategy?',
      answer: 'SEO should be a key component of your marketing strategy...',
    },
    {
        question: 'How should SEO be incorporated with our overall marketing strategy?',
        answer: 'SEO should be a key component of your marketing strategy...',
      },
      {
        question: 'How should SEO be incorporated with our overall marketing strategy?',
        answer: 'SEO should be a key component of your marketing strategy...',
      },
      {
        question: 'How should SEO be incorporated with our overall marketing strategy?',
        answer: 'SEO should be a key component of your marketing strategy...',
      },
      {
        question: 'How should SEO be incorporated with our overall marketing strategy?',
        answer: 'SEO should be a key component of your marketing strategy...',
      },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim 
        ad minim veniam, quis nostrud exerci tation ullamcorper.</p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
